import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';;
import { UserService } from 'src/app/services/user.service';
import { TournamentsService } from 'src/app/services/tournamnet.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-admin-matches-info',
  templateUrl: './matches-info.component.html',
  styleUrls: ['./matches-info.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class MatchesInfoComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>(); 
  public item;
  public profileDetails;
  public loggedInUser;
  public userId;
  public isLoggedIn: boolean = false;
  public data: any;
  public careerDetails;
  public highestSkillJumpDetails;
  public options = {
    title: {
      display: true,
      text: "My Title",
      fontSize: 16,
    },
    legend: {
      position: "bottom",
    },
  };
  matchTypes = environment.matchTypes;
  public opponentList: any = [];
  public tournamentList: any = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: "1024px",
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: "768px",
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1,
    },
  ];
  rankData: any;
  matchesData: any;
  basicOptions: any;
  public paginationOption = environment.pagination;
  public matchList: any = [];
  public upcommingmatchList: any=[];
  public pastMatchList: any =[];
  public totalpastMatchCount : Number = 0;
  public totalupcommingmatchCount: Number = 0;
  public showUpcomming:boolean = false;
  private lazyLoadEvent: LazyLoadEvent;
  public downloadFlg: boolean = false;
  public loading: boolean = false;
  public totalRecords: Number = 0;
  public startDate: Date;
  public endDate: Date;
  public errorMessage;
  public searchby;
  playerName: any;
  username: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private tournamentsService: TournamentsService,
  ) { }

  ngOnInit(): void {
    this.basicOptions = {
      plugins: {
        legend: {
          labels: {
            color: "#495057",
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: "#495057",
          },
          grid: {
            color: "#ebedef",
          },
        },
        y: {
          ticks: {
            color: "#495057",
          },
          grid: {
            color: "#ebedef",
          },
        },
      },
    };
    this.rankData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Rank",
          data: [0, 10, 5, 2, 20, 1, 12, 25, 20, 10, 8],
          fill: false,
          borderColor: "#42A5F5",
          tension: 0.4,
        },
      ],
    };
    this.matchesData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Matches",
          data: [10, 1, 15, 23, 2, 12, 15, 5, 1, 10, 8],
          fill: false,
          borderColor: "#7CFC00",
          tension: 0.4,
        },
      ],
    };
    this.data = {
      // labels: ['Skill', 'Skill', 'Skill'],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
          hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
        },
      ],
    };

    this.userId = this.route.snapshot.paramMap.get("id");
    this.loadPastMatches(this.lazyLoadEvent);
      this.loadUpcomingMatches(this.lazyLoadEvent);
  }
  loadUpcomingMatches(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&type=upcoming";
    var pagenumber = 1;
    var params = "";
    var rows=4;
    if (event != undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 4;
      }
    }
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    this.tournamentsService.getMatchList(this.userId, query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        this.matchList = [];
        this.upcommingmatchList = data["upcomingPlayerMatches"];
        this.playerName=this.upcommingmatchList[0].playerName
        // this.totalupcommingmatchCount = this.upcommingmatchList.length;
        this.totalupcommingmatchCount = data["upcommingMatchCount"];
        this.totalRecords = this.totalupcommingmatchCount;
        if (!this.username) {
          this.username = data["userInfo"]?.name;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  loadPastMatches(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    var query = "?filterByDisable=false&type=past";
    var pagenumber = 1;
    var params = "";
    var rows=4;
    if (
      this.searchby != undefined &&
      this.startDate != undefined &&
      this.endDate != undefined
    ) {
      params += "&filterByDate=" + this.searchby.value;
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event != undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 4;
      }
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    this.tournamentsService.getMatchList(this.userId, query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        this.matchList = [];
        this.pastMatchList = data["pastPlayerMatches"];
        this.totalpastMatchCount = this.pastMatchList.length;
        this.username = data["userInfo"]?.name; 
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.item = data;
        if (this.item) {
          this.profileDetails = this.item;
        }

      }, err => {

      });

  }

  getTournamentsList() {
    this.tournamentsService.getTournamentsList().then(
      data => {
        this.tournamentList = data;

      }, err => {

      });
  }
  clickTournament(){
    this.router.navigate(["tournaments"]);
  }
  onclickTournamentdetails(tournamentid) {
    this.router.navigate(["tournaments/factsheet/" + tournamentid]);
  }
  onChangeTab(event) {
    this.totalRecords = (event.index === 0) ? this.totalupcommingmatchCount : this.totalpastMatchCount;
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
